import { Section } from "../components/Section";
import * as React from "react";
import styled from "styled-components";
import { WordShift } from "../components/WordShift";
import { TABLET } from "../constant/Breakpoints";
import * as AnimatedImage from "../components/animated-image";
import { layers as techLayers } from "../assets/images/services/tech/parallax";
import { layers as creaLayers } from "../assets/images/services/creation/parallax";
import { layers as stratLayers } from "../assets/images/services/strategie/parallax";

const TopSection = styled(Section)`
  padding-bottom: 0;
`;

const MiddleSection = styled(Section)`
  padding-top: 0;
  padding-bottom: 0;
`;

const BottomSection = styled(Section)`
  padding-top: 0;
`;

const BigText = styled.div`
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;

  @media (max-width: ${TABLET}px) {
    text-align: center;
  }
`;

const BigTextRight = styled(BigText)`
  text-align: right;
`;

const BigTextLeft = styled(BigText)`
  text-align: left;
`;

const MidText = styled.div`
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: 500;
  margin-top: 15px;

  @media (max-width: ${TABLET}px) {
    text-align: center;
  }
`;

const MidTextRight = styled(MidText)`
  text-align: right;
`;

const MidTextLeft = styled(MidText)`
  text-align: left;
`;

const SmallText = styled.div`
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 100;
  margin-bottom: 5px;

  @media (max-width: ${TABLET}px) {
    text-align: center;
  }
`;

const SmallTextRight = styled(SmallText)`
  text-align: right;
`;

const SmallTextLeft = styled(SmallText)`
  text-align: left;
`;

const Service = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;

  > div {
    flex: 1;
    padding: 0 48px;

    @media (max-width: ${TABLET}px) {
      padding: 0;
    }
  }
`;

const ServiceRight = styled(Service)`
  @media (max-width: ${TABLET}px) {
    flex-direction: column;
  }
`;

const ServiceLeft = styled(Service)`
  @media (max-width: ${TABLET}px) {
    flex-direction: column-reverse;
  }
`;

const ServiceText = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  @media (max-width: ${TABLET}px) {
    align-items: center;
  }
`;

const ServiceTextRight = styled(ServiceText)`
  align-items: flex-end;
`;

const ServiceTextLeft = styled(ServiceText)`
  align-items: flex-start;
`;

const CreationWords = ["différencier", "affirmer", "réinventer"];
const StrategieWords = ["inoubliables", "impactantes", "attractives"];
const TechWords = ["construire", "rêver", "soutenir"];

export const ServiceCreation = () => (
  <TopSection id="services">
    <ServiceRight>
      <ServiceTextRight>
        <BigTextRight>Création</BigTextRight>
        <SmallTextRight>
          Design graphique | Motion Design | Illustration
        </SmallTextRight>
        <SmallTextRight>
          Photographie | Journalisme | Vidéo | Edition
        </SmallTextRight>
        <MidTextRight>
          Nous pensons que votre identité compte autant que l'engagement de
          votre projet.
        </MidTextRight>
        <MidTextRight>
          Nous vous aidons à vous <WordShift words={CreationWords} />
        </MidTextRight>
      </ServiceTextRight>
      <div>
        <AnimatedImage.ParallaxScroll
          sources={creaLayers}
          alt="Creation illustration"
        />
      </div>
    </ServiceRight>
  </TopSection>
);

export const ServiceStrategie = () => (
  <MiddleSection>
    <ServiceLeft>
      <div>
        <AnimatedImage.ParallaxScroll
          sources={stratLayers}
          alt="Strategy illustration"
        />
      </div>
      <ServiceTextLeft>
        <BigTextLeft>Stratégie</BigTextLeft>
        <SmallTextLeft>
          Planning stratégique | Campagnes de communication
        </SmallTextLeft>
        <SmallTextLeft>
          Stratégie de marque | Conseil &#38; Suivi de projet
        </SmallTextLeft>
        <MidTextLeft>
          Nous pensons que le choix de la fréquence, l’intention et la
          formulation de vos messages influence directement leur impact.
        </MidTextLeft>
        <MidTextLeft>
          Nous concevons avec vous des campagnes de communication{" "}
          <WordShift words={StrategieWords} />
        </MidTextLeft>
      </ServiceTextLeft>
    </ServiceLeft>
  </MiddleSection>
);

export const ServiceTech = () => (
  <BottomSection>
    <ServiceRight>
      <ServiceTextRight>
        <BigTextRight>Tech</BigTextRight>
        <SmallTextRight>Développement Web | Design UI-UX</SmallTextRight>
        <MidTextRight>
          Nous pensons que la fiabilité et la performance de vos outils
          numériques renforcent la qualité de votre projet.
        </MidTextRight>
        <MidTextRight>
          Nous développons les solutions qui vous permettent de{" "}
          <WordShift words={TechWords} center={true} /> le monde de demain.
        </MidTextRight>
      </ServiceTextRight>
      <div>
        <AnimatedImage.ParallaxScroll
          sources={techLayers}
          alt="Web development illustration"
        />
      </div>
    </ServiceRight>
  </BottomSection>
);
